import axios from 'utils/axios';

const RequestResetLinkService = async (data) => {
    await axios.post('api/auth/forgot-password', data);
};

export default RequestResetLinkService;
